import { type Object3D, Vector3 } from 'three'

type Axis = 'x' | 'y' | 'z'

export const getWorldPositionAxis = (object: Object3D, axis: Axis) => {
  return object.getWorldPosition(new Vector3())[axis]
}

export const setWorldPositionAxis = (object: Object3D, axis: Axis, value: number) => {
  const world = object.getWorldPosition(new Vector3())
  world[axis] = value
  object.position.copy(object.parent ? object.parent.worldToLocal(world) : world)
}
